import { OmrHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetOfferingTypesForClubRegistrationData = (orgUnitId, isOrganizationRegistration, state, setState) => {
  if (state.isArrayLoading !== true
    && !state.message && (
      state.isArrayLoaded !== true
      || orgUnitId !== state.orgUnitId)) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...',
      orgUnitId
    };
    setState(newState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const url = `/OfferingType/ClubRegistration?orgUnitId=${orgUnitIdForUrl}&isOrganizationRegistration=${isOrganizationRegistration}`;
    OmrHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: '',
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOfferingTypesForClubRegistrationData;